import {
  ChangeJournalViewItemServiceComponentConfig,
  ChangeJournalViewItemServiceProvider,
  vsProviderName as ChangeJournalViewItemServiceProviderName,
} from "../../../../records/changeJournal/changeJournalViewComponent/itemObjectDetail";
import { vsModuleName as changeJournalModule } from "../../../../records/changeJournal/module";

import {
  vsComponentName as changeJournalMachineItemViewComponentName,
  changeJournalMachineItemViewComponentOptions,
} from "./machine/component";

import {
  vsComponentName as changeJournalMachineConfigurationItemViewComponentName,
  changeJournalMachineConfigurationItemViewComponentOptions,
} from "./machineConfiguration/component";

import angular, { IPromise } from "angular";
import {
  machineConfigurationObjectName,
  machineObjectName,
} from "../../../shared/names";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../records/server/serverUtility";
import { ServiceResponse } from "../../../../records/server/query";
import {
  ChangeJournalObject,
  ChangeJournalObjectIdentifier,
} from "../../../../records/changeJournal/changeJournalViewComponent/models";

export const vsModuleName = "SlotTrak.Machines.Config.ChangeJournal";

angular
  .module(
    vsModuleName,
    [changeJournalModule],
    [
      ChangeJournalViewItemServiceProviderName,
      (
        changeJournalViewItemServiceProvider: ChangeJournalViewItemServiceProvider,
      ) => {
        changeJournalViewItemServiceProvider.addTypeComponent(
          machineObjectName,
          <ChangeJournalViewItemServiceComponentConfig>{
            componentName: changeJournalMachineItemViewComponentName,
            resolveObjects: [
              "objectIdentifier",
              ServerUtilityName,
              getMachineObjects,
            ],
            resolveInfoSref: (object) => ({
              sref: "main.machines.detail.configurations",
              params: {
                machineId: object.id.ObjectId,
              },
            }),
          },
        );
        changeJournalViewItemServiceProvider.addTypeComponent(
          machineConfigurationObjectName,
          {
            componentName:
              changeJournalMachineConfigurationItemViewComponentName,
            resolveInfoSref: (object: ChangeJournalObject) => ({
              sref: "main.machines.detail.configurations",
              params: {
                machineId: object.object.MachineId,
              },
            }),
            resolveObjects: [
              "objectIdentifier",
              ServerUtilityName,
              (
                id: ChangeJournalObjectIdentifier,
                serverUtility: ServerUtility,
              ) =>
                serverUtility
                  .query<any>({
                    url: "/api/machines/MachineConfiguration",
                    query: {
                      Id: id.ObjectId,
                    },
                  })
                  .then((queryResult) =>
                    getMachineObjects(
                      {
                        ObjectId: queryResult.Results[0].MachineId,
                        ObjectName: machineObjectName,
                      },
                      serverUtility,
                    ),
                  ),
            ],
          },
        );
      },
    ],
  )
  .component(
    changeJournalMachineItemViewComponentName,
    changeJournalMachineItemViewComponentOptions,
  )
  .component(
    changeJournalMachineConfigurationItemViewComponentName,
    changeJournalMachineConfigurationItemViewComponentOptions,
  );

function getMachineObjects(
  changeJournalObjectIdentifier: ChangeJournalObjectIdentifier,
  serverUtility: ServerUtility,
): IPromise<ChangeJournalObject[]> {
  return serverUtility
    .getById<ServiceResponse<any>>({
      url: "/api/machines/Machine",
      id: changeJournalObjectIdentifier.ObjectId,
    })
    .then((machineResponse): ChangeJournalObject[] => {
      const { Result: machine } = machineResponse;

      return [
        {
          id: {
            ObjectId: machine.Id,
            ObjectName: machineObjectName,
          },
          object: machine,
        },
        ...(machine.Configs ?? []).map((config: any) => ({
          id: {
            ObjectId: config.Id,
            ObjectName: machineConfigurationObjectName,
          },
          object: config,
        })),
      ];
    });
}
